import { Dialog as MuiDialog, DialogActions, DialogContent } from '@mui/material';
import React from 'react';
import { ButtonOutlineMedium, ButtonPrimaryMedium } from '../Buttons';
import { BodyLargeEmphasized } from '../Typography';
import styles from './Dialog.styles';

export interface DismissDialogProps {
  onCancel: () => void;
}

interface Props {
  title: string;
  description: React.ReactNode;
  isOpen: boolean;
  icon?: React.ReactNode;
  cancelButtonText?: string;
  confirmButtonText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const Dialog: React.FC<Props> = ({
  title,
  description,
  icon,
  isOpen,
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Confirm',
  onConfirm,
  onCancel,
}) => {
  return (
    <MuiDialog
      open={isOpen}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={styles.dialog}
    >
      {icon && <div className={styles.icon}>{icon}</div>}
      <BodyLargeEmphasized className={styles.title}>{title}</BodyLargeEmphasized>
      <DialogContent>{description}</DialogContent>
      <DialogActions>
        <ButtonOutlineMedium onClick={onCancel}>{cancelButtonText}</ButtonOutlineMedium>
        <ButtonPrimaryMedium autoFocus onClick={onConfirm}>
          {confirmButtonText}
        </ButtonPrimaryMedium>
      </DialogActions>
    </MuiDialog>
  );
};
